import { SearchOff } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export const ChartNoResultPlaceholder = () => {
  return (
    <Box
      sx={{
        display: 'grid',
        placeItems: 'center',
        height: 'calc(100% - 64px)',
        minHeight: '200px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <SearchOff />
        <Typography variant='subtitle1'>No results found</Typography>
      </Box>
    </Box>
  );
};
